/* eslint-disable @typescript-eslint/no-unused-vars */
import { appConfig, AppConfigEnvKey } from "./app.config";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

const isFirefox = firefox > 0;
const authorityParam = `https://login.microsoftonline.com/${appConfig.get(
    AppConfigEnvKey.REACT_APP_ADB2C_TENANT_ID
)}`;

const clientIdParam = appConfig.get(AppConfigEnvKey.REACT_APP_CLIENT_ID);

const redirectUriParam = appConfig.get(AppConfigEnvKey.REACT_APP_URI_REDIRECT);

export const msalConfig = {
    auth: {
        clientId: clientIdParam,
        authority: authorityParam,
        redirectUri: redirectUriParam,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
};

const templatemanagerParam = appConfig.get(
    AppConfigEnvKey.REACT_APP_AD_SCOPE_TEMPLATE_MANAGER
);

const docenteParam = appConfig.get(AppConfigEnvKey.REACT_APP_AD_SCOPE_DOCENTE);

const reportParam = appConfig.get(
    AppConfigEnvKey.REACT_APP_AD_SCOPE_DOCENTEREPORT
);

export const SCOPES = {
    OPENID: "openid",
    PROFILE: "profile",
    SCHOOL_READ: "School.Read",
    USER_READ: "User.Read",
    TEMPLATE_MANAGER: templatemanagerParam,
    DOCENTE: docenteParam,
    DOCENTE_REPORT: reportParam,
};
